import { TRateCardFuelLevies, TRateCardFuelLeviesResponse } from '@types';

// Folds the API's older singular `customer` slot into `customer_levies`
export const normaliseFuelLevies = (fuelLevies?: TRateCardFuelLeviesResponse | null): TRateCardFuelLevies => {
	const { customer, customer_levies, ...rest } = fuelLevies ?? {};

	if (Array.isArray(customer_levies)) {
		return { ...rest, customer_levies };
	}

	return { ...rest, customer_levies: customer ? [customer] : [] };
}
